module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/assessment_achievements/5@2x_1e203acc7b5e6ff936f5b3f60fba855f.png";